import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {$accountFactory} from "../../$account.factory";

export class AccountListItemCtrl implements IController {

  accountId: string;
  excludeIds: any;
  showLink: any;
  onAdd: Function;

  private account: AccountModel;

  /* @ngInject */
  constructor(private $account: $accountFactory, private $scope: IScope) {
  }

  $onInit() {
    if (!this.excludeIds) {
      this.excludeIds = [];
    }
    if (this.accountId) {
      this.$account(this.accountId).$bindCtrlToId(this.$scope, this, 'account', 'accountId');
    }
  };

  $onChanges(changes) {
    if (changes.accountId && !changes.accountId.isFirstChange()) {
      this.$onInit();
    }
  };

  showAdd() {
    return _.isFunction(this.onAdd);
  }

  getDisabledValue() {
    if (!this.account) {
      return true;
    }
    return _.findIndex(this.excludeIds, (id) => {
      return this.account.id === id;
    }) !== -1;
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountListItem', {
    bindings: {
      accountId: '<',
      excludeIds: '<?',
      showLink: '<?',
      onAdd: '&?'
    },
    template: require('./account-list-item.html').default,
    controller: AccountListItemCtrl
  });

